import React, { useState, useRef, useEffect } from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"

import BackgroundImage from "gatsby-background-image"
import { device } from "../../utils/breakpoints"
import { anims, borders, colors } from "../../utils/theme"
import CardBenefits from "./CardBenefits"

const BeneficiosSection = styled(BackgroundImage)`
  width: 100%;
  background-position: center center;
  background-repeat: none;
  background-size: cover;
  opacity: 1 !important;
  padding: 2rem 0;
`

function Beneficios() {
  const { image } = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "back-beneficios.png" }) {
        sharp: childImageSharp {
          fluid(quality: 80, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <BeneficiosSection
      tag="section"
      fluid={image.sharp.fluid}
      fadeIn="soft"
      backgroundColor={`#1a1a1a`}
      id="beneficios"
    >
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
              <CardBenefits />
          </Col>
        </Row>
      </Container>
    </BeneficiosSection>
  )
}

export default Beneficios
